import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import GoogleMapReact from "google-map-react";
import NVD3Chart from "react-nvd3";
import d3 from "d3";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Pie } from "react-chartjs-2";
import Config from "../../Config.js";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import QRCode from "qrcode.react";
import { CSVLink } from "react-csv";
import {
  countrycsvheaders,
  Citycsvheaders,
  Categorycsvheaders,
  Subcategorycsvheaders,
} from "./CsvHeaders/CsvHeaders";
import { countryList } from "../../components/Conteries";
import { getpersonalTimeWiseScanningAnalyticReport } from "../../api/reportApi";
import {
  GetDominUrl
} from "../../api/apiconfiguration.js"

import {PersonalTimeWiseAnalysis} from '../../components/Modal/modal.js' 
import {PersonalCountrywisescans} from '../../components/Modal/modal.js' 
import {PersonalBestScancategoryisall} from '../../components/Modal/modal.js' 
import {PersonalLocationscitywisescans} from '../../components/DataTable/datatable.js'
import {PersonalCategorywisescanningDetails} from '../../components/DataTable/datatable.js'
import {PersonalSubbcattegorywisescanningtable} from '../../components/DataTable/datatable.js'


const Personalreports = (props) => {
  const { personallist } = props;
  const { PersonalID } = props;
  console.log("PersonalID===>", PersonalID);
  let history = useHistory();
  const [modalCountry, setmodalCountry] = useState(false);
  const [modalCity, setmodalCity] = useState(false);
  const [modalVendors, setmodalVendors] = useState(false);
  const [graphData, setgraphData] = useState(null);
  const [selectStartDate, setselectStartDate] = useState(
    Moment(new Date()).subtract("days", 30)
  );
  const [selectEndDate, setselectEndDate] = useState(Moment(new Date()));
  const [Isloading, setIsloading] = useState(false);
  const [bestscancountry, setbestscancountryisall] = useState(false);
  const [personalID, setpersonalID] = useState("");
  const [modalCategory, setmodalCategory] = useState(false);
  const [modalsubCategory, setModalsubCategory] = useState(false);
  const [Locationswisecanning, setLocationswisecanning] = useState([]);
  const [LocationsCitywisecanning, setLocationsCitywisecanning] = useState([]);
  const [DatatablecountryWiseScanLits, setDatatablecountryWiseScanLits] =
    useState([]);
  const [bestScancategorydetailsisall, setbestScancategorydetailsisall] =
    useState(false);
  const [Categorywisescanning, setCategorywisescanning] = useState([]);
  const [Subbcattegorywisescanning, setSubbcattegorywisescanning] = useState(
    []
  );
  const [Subbcattegorywisescanningishow, setSubbcattegorywisescanningishow] =
    useState(false);
  const [bestScancategoryisall, setbestScancategoryisall] = useState(false);
  const [DatatableCategoryList, setDatatableCategoryList] = useState([]);
  const [CategoryDownloadReady, setCategoryDownloadReady] = useState(false);
  const [Categorycsvdata, setCategorycsvdata] = useState([]);

  const [SubcategoryDownloadReady, setSubcategoryDownloadReady] =
    useState(false);
  const [Subcategorycsvdata, setSubcategorycsvdata] = useState([]);

  const [bDownloadReady, setDownloadReady] = useState(false);
  const [countrycsvdata, setcountrycsvdata] = useState([]);

  const [cityDownloadReady, setcityDownloadReady] = useState(false);
  const [Citycsvdata, setCitycsvdata] = useState([]);
  const [articleTimeWiseScanListDetalis, setarticleTimeWiseScanListDetalis] =
    useState([]);
  const [IstimewisemodalOpen, setIstimewisemodalOpen] = useState(false);
  const [bestscancountryishow, setbestscancountryishow] = useState(false);
  const [bestsCityallshow, setbestsCityallshow] = useState(false);
  const countrycsvRef = useRef(null);
  const CitycsvRef = useRef(null);
  const CategorycsvRef = useRef(null);
  const SubcategorycsvRef = useRef(null);

  const domainFrontUrl = useRef("");

  useEffect(async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      // LoadGraph(selectStartDate, selectEndDate, "")
     await getDominUrl();
      if (
        PersonalID !== null &&
        PersonalID !== undefined &&
        PersonalID !== ""
      ) {
        localStorage.setItem("localPersonalID", PersonalID);
        setpersonalID(PersonalID);
        LoadGraph(selectStartDate, selectEndDate, PersonalID);
      } else {
        localStorage.setItem("localPersonalID", "");
        setpersonalID("");
        LoadGraph(selectStartDate, selectEndDate, "");
      }
    }
  }, []);

  const getDominUrl =async ()=>{
    let response = await GetDominUrl();
    if(response !== null && response.domainName !== null && response.domainName !== ""){
      domainFrontUrl.current = response.domainName;
      console.log("domainFrontUrl.current==>" ,domainFrontUrl.current)
    }
    else{
      domainFrontUrl.current="";
    }
}
  const toggleCountry = () => {
    setmodalCountry(!modalCountry);
    // getCountrywisescanningDetail(item);
  };
  const getCountrywisescanningDetail = (CountryName) => {
    if (
      CountryName?.name !== null &&
      CountryName?.name !== undefined &&
      CountryName?.name !== ""
    ) {
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";

      let myPersonalID = localStorage.getItem("localPersonalID");
      if (!myPersonalID) {
        myPersonalID = "";
      }

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/PersonalLocationsCountryWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CountryName=" +
        CountryName?.name +
        "&PageCount=10000" +
        "&PersonalQrCodeId=" +
        myPersonalID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalCountry(true);
          setLocationswisecanning(responseJson);
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalCountry(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setLocationswisecanning([]);
        });
    } else {
      setmodalCountry(false);
      setLocationswisecanning([]);
      console.log("Country Name Not Found");
    }
  };

  const toggleCity = () => {
    // getcitywisescanningDetail(item);
    setmodalCity(!modalCity);
  };

  const getcitywisescanningDetail = (CountryName) => {
    if (
      CountryName?.countryName !== null &&
      CountryName?.countryName !== undefined &&
      CountryName?.countryName !== ""
      // &&
      // CountryName?.cityName !== null &&
      // CountryName?.cityName !== undefined &&
      // CountryName?.cityName !== ""
    ) {
      var cityname = "";
      if (
        CountryName?.cityName !== null &&
        CountryName?.cityName !== "null" &&
        CountryName?.cityName !== undefined &&
        CountryName?.cityName !== ""
      ) {
        cityname = CountryName?.cityName;
      }

      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";
      let myPersonalID = localStorage.getItem("localPersonalID");
      if (!myPersonalID) {
        myPersonalID = "";
      }

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/PersonalLocationsCityWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CountryName=" +
        CountryName?.countryName +
        "&cityName=" +
        cityname +
        "&PageCount=10000" +
        "&PersonalQrCodeId=" +
        myPersonalID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalCity(true);
          // setLocationsCitywisecanning(responseJson);
          let responseJsonTemp = responseJson;
          if (responseJsonTemp) {
            responseJsonTemp.forEach((item, index) => {
              item.sr = index + 1;
            });
            setLocationsCitywisecanning(responseJsonTemp);
          } else {
            setLocationsCitywisecanning([]);
          }
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalCity(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setLocationsCitywisecanning([]);
        });
    } else {
      setmodalCity(false);
      setLocationsCitywisecanning([]);
      console.log("Country  Name && City Name Not Found");
    }
  };

  const dateRange = {
    currentWeek:
      Moment(selectStartDate).format("DD / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("DD / MM / YYYY"),

    prevWeek:
      Moment(selectStartDate).format("D / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("D / MM / YYYY"),
  };
  const handleDateApplyEvent = (event, picker) => {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");

    var currentWeek =
      startDate.format("D MMMM YYYY") + " - " + endDate.format("D MMMM YYYY");
    var prevWeek =
      Moment(startDate).subtract("days", gap).format("D MMMM") +
      " - " +
      Moment(startDate).subtract("days", 1).format("D MMMM YYYY");

    setselectEndDate(new Date(picker.endDate));
    setselectStartDate(new Date(picker.startDate));
    LoadGraph(picker.startDate, picker.endDate, personalID);
  };
  const getDate = (minusDate) => {
    var d = new Date();
    d = d.setDate(d.getDate() - minusDate);
    return d;
  };

  const areaChartOptions = {
    pointSize: 0.5,
    useInteractiveGuideline: true,
    durection: 300,
    showControls: false,
    controlLabels: {
      stacked: "Stacked",
    },
    yAxis: {
      tickFormat: d3.format(",.0f"),
    },
    xAxis: {
      tickFormat: function (d) {
        var monthsName = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        d = new Date(parseInt(d));
        d = monthsName[d.getMonth()] + " " + d.getDate();
        return d;
      },
    },
  };
  const map = {
    center: {
      lat: 59.95,
      lng: 30.33,
    },
    zoom: 9,
  };

  const pieChart = {
    data: {
      labels: ["Android", "ISO"],
      datasets: [
        {
          data: [300, 160],
          height: [10],
          width: [10],
          backgroundColor: ["#5B8FF9", "#61DDAA"],
          borderColor: ["#5B8FF9", "#61DDAA"],
          borderWidth: 2,
          label: "My dataset",
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
    },
  };

  const LoadGraph = async (stardate, enddate, personalqrcodeId) => {
    setIsloading(true);
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let subUserIDList = localStorage.getItem("subUserIDList");
    let GraphstartDate = Moment(stardate).format("YYYY/MM/DD") + " 00:00:00";
    let GraphEndDate = Moment(enddate).format("YYYY/MM/DD") + " 00:00:00";
    fetch(
      Config.apiUrl +
      "QRCodeScanHistory/PersonalQrCodeScanningAnalyticReport?StartDate=" +
      GraphstartDate +
      "&EndDate=" +
      GraphEndDate +
      "&PageCount=10000" +
      "&PersonalQrCodeId=" +
      personalqrcodeId,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          subUserCompanyID: subUserIDList,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        setIsloading(false);
        // setpersonalID(personalqrcodeId);
        document.body.style.overflow = "auto";
        console.log("responseJson Grap", responseJson);
        setgraphData(responseJson);
        let bestScancategoryWiseListTemp =
          responseJson?.personalQrCodeCategoryWiseScanList;
        if (bestScancategoryWiseListTemp) {
          bestScancategoryWiseListTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatableCategoryList(bestScancategoryWiseListTemp);
        } else {
          setDatatableCategoryList([]);
        }
        let responseJsonTemp = responseJson?.personalQrCodeCountryWiseScanList;
        if (responseJsonTemp) {
          responseJsonTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatablecountryWiseScanLits(
            responseJsonTemp.filter((x) => x.name !== "country13")
          );
        } else {
          setDatatablecountryWiseScanLits([]);
        }
      })
      .catch((error) => {
        setIsloading(false);
        document.body.style.overflow = "auto";
        console.log(error);
        setgraphData(null);
      });
  };

  const selectpersonalQrcode = (personalqrcode) => {
    setpersonalID(personalqrcode);
    localStorage.setItem("localPersonalID", personalqrcode);
    LoadGraph(selectStartDate, selectEndDate, personalqrcode);
  };

  useEffect(() => {
    if (countrycsvRef && countrycsvRef.current && bDownloadReady) {
      countrycsvRef.current.link.click();
      setDownloadReady(false);
    }
  }, [bDownloadReady]);

  const handleActioncountry = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (Locationswisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...Locationswisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let tempdata = {
            sr: index + 1,
            cityName: element.cityName ? element.cityName : "N/A",
            totalScanCount: element.totalScanCount,
            countryName: element.countryName ? element.countryName : "N/A",
          };
          withheder.push(tempdata);
        }
        setcountrycsvdata(withheder);
        setDownloadReady(true);
      }
    }
  };

  useEffect(() => {
    if (CitycsvRef && CitycsvRef.current && cityDownloadReady) {
      CitycsvRef.current.link.click();
      setcityDownloadReady(false);
    }
  }, [cityDownloadReady]);
  const handleActionCity = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (LocationsCitywisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...LocationsCitywisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let Fileimagepath = "";
          if (element.productImagepath) {
            Fileimagepath = Config.contentUrl + element.productImagepath;
          }
          let tempdata = {
            sr: index + 1,
            cityName: element.cityName ? element.cityName : "N/A",
            totalScanCount: element.totalScanCount,
            countryName: element.countryName ? element.countryName : "N/A",
            itemName: element.productName ? element.productName : "N/A",
            image: element.productImagepath ? Fileimagepath : "N/A",
          };
          withheder.push(tempdata);
        }
        setCitycsvdata(withheder);
        setcityDownloadReady(true);
      }
    }
  };

  //Praveen New work

  useEffect(() => {
    if (CategorycsvRef && CategorycsvRef.current && CategoryDownloadReady) {
      CategorycsvRef.current.link.click();
      setCategoryDownloadReady(false);
    }
  }, [CategoryDownloadReady]);
  const handleActionCategory = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (Categorywisescanning.length > 0) {
        let withheder = [];
        let csvdata = [...Categorywisescanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];

          let tempdata = {
            sr: index + 1,
            categoryName: element.categoryName ? element.categoryName : "N/A",
            totalScanCount: element.totalScanCount,
            subCategoryName: element.subCategoryName
              ? element.subCategoryName
              : "N/A",
          };
          withheder.push(tempdata);
        }
        setCategorycsvdata(withheder);
        setCategoryDownloadReady(true);
      }
    }
  };

  useEffect(() => {
    if (
      SubcategorycsvRef &&
      SubcategorycsvRef.current &&
      SubcategoryDownloadReady
    ) {
      SubcategorycsvRef.current.link.click();
      setSubcategoryDownloadReady(false);
    }
  }, [SubcategoryDownloadReady]);
  const handleActionsubCategory = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (Subbcattegorywisescanning.length > 0) {
        let withheder = [];
        let csvdata = [...Subbcattegorywisescanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];

          let Fileimagepath = "";
          if (element.productImagepath) {
            Fileimagepath = Config.contentUrl + element.productImagepath;
          }
          let tempdata = {
            sr: index + 1,
            categoryName: element.categoryName ? element.categoryName : "N/A",
            totalScanCount: element.totalScanCount,
            subCategoryName: element.subCategoryName
              ? element.subCategoryName
              : "N/A",
            itemName: element.productName ? element.productName : "N/A",
            image: element.productImagepath ? Fileimagepath : "N/A",
          };
          withheder.push(tempdata);
        }
        setSubcategorycsvdata(withheder);
        setSubcategoryDownloadReady(true);
      }
    }
  };
  const toggleCetegoryTableclosed = () => {
    setbestScancategoryisall(false);
  };
 

 

  const togglecategory = (Citem) => {
    console.log("Citem==>", Citem);
    if (Citem != null && Citem !== undefined && Citem != "") {
      getCategorywisescanningDetail(Citem?.categoryID);
    }
    // setmodalCategory(!modalCategory);
  };

  const togglecategorydetail = (item) => {
    console.log("togglecategorydetail====>", item);
    if (item != null && item !== undefined && item != "") {
      getSubcategorywisescanningDetail(item?.categoryID, item?.subCategoryID);
    }
  };
  const getCategorywisescanningDetail = (CID) => {
    let subUserIDList = localStorage.getItem("subUserIDList");
    if (CID !== null && CID !== undefined && CID !== "") {
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";
      let myPersonalID = localStorage.getItem("localPersonalID");
      if (!myPersonalID) {
        myPersonalID = "";
      }
      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/PersonalQrCodeCategoryWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CategoryID=" +
        CID +
        "&PageCount=10000" +
        "&PersonalQrCodeId=" +
        myPersonalID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            subUserCompanyID: subUserIDList,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalCategory(true);
          let responseJsonTemp = responseJson;
          if (responseJsonTemp) {
            responseJsonTemp.forEach((item, index) => {
              item.sr = index + 1;
            });
            setCategorywisescanning(responseJsonTemp);
          } else {
            setCategorywisescanning([]);
          }
          // setCategorywisescanning(responseJson)
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setIsloading(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setCategorywisescanning([]);
        });
    } else {
      setmodalCategory(false);
      setCategorywisescanning([]);
      console.log("Category Id Not Found");
    }
  };

  const getSubcategorywisescanningDetail = (CID, SID) => {
    if (
      CID !== null &&
      CID !== undefined &&
      CID !== "" &&
      SID !== null &&
      SID !== undefined &&
      SID !== ""
    ) {
      let subUserIDList = localStorage.getItem("subUserIDList");
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";
      let myPersonalID = localStorage.getItem("localPersonalID");
      if (!myPersonalID) {
        myPersonalID = "";
      }
      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/PersonalQrCodeSubCategoryWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CategoryID=" +
        CID +
        "&subCategoryID=" +
        SID +
        "&PageCount=10000" +
        "&PersonalQrCodeId=" +
        myPersonalID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            subUserCompanyID: subUserIDList,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setIsloading(false);
          document.body.style.overflow = "auto";
          setModalsubCategory(true);
          let responseJsonTemp = responseJson;
          if (responseJsonTemp) {
            responseJsonTemp.forEach((item, index) => {
              item.sr = index + 1;
            });
            setSubbcattegorywisescanning(responseJsonTemp);
          } else {
            setSubbcattegorywisescanning([]);
          }
          // setSubbcattegorywisescanning(responseJson)
        })
        .catch((error) => {
          setIsloading(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setSubbcattegorywisescanning([]);
        });
    } else {
      setIsloading(false);
      setSubbcattegorywisescanning([]);
      setModalsubCategory(false);
      console.log("Sub Category Id Not Found");
    }
  };

  const ToggleTimewisemodalOpen = () => {
    setIstimewisemodalOpen(!IstimewisemodalOpen);
  };

  const GetPersonalTimeWiseScanningAnalyticReport = async () => {
    let myPersonalID = localStorage.getItem("localPersonalID");
    if (!myPersonalID) {
      myPersonalID = "";
    }
    let StartDate = Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
    let EndDate = Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
    let data = await getpersonalTimeWiseScanningAnalyticReport(
      StartDate,
      EndDate,
      10000,
      myPersonalID
    );
    ToggleTimewisemodalOpen();
    setarticleTimeWiseScanListDetalis(data);
  };

  
  const togglecountryTableclosed = () => {
    setbestscancountryishow(false);
  };

  return (
    <div>
      <LoaderSpinner isrefresh={Isloading} />
      <h1 className="page-header mb-3">Personal Qr Code Scanning Analytics</h1>
      <div className="d-sm-flex align-items-center mb-3">
        <DateRangePicker
          startDate={selectStartDate}
          endDate={selectEndDate}
          onApply={handleDateApplyEvent}
        >
          <button className="btn btn-inverse mr-2 text-truncate">
            <i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i>
            <span>{dateRange.currentWeek}</span>
            <b className="caret"></b>
          </button>
        </DateRangePicker>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body">
              <div
                className=" p-15"
                style={{ borderWidth: "1px", borderStyle: "dashed" }}
              >
                <form
                  className="row align-items-center"
                  action=""
                  method="POST"
                >
                  <div className="form-group col-xl-9 col-lg-10 col-md-12  row align-items-center mb-0">
                    <label className="col-form-label col-lg-5  col-md-12">
                      Select Personal
                    </label>
                    <div className="col-lg-7 col-md-8">
                      <select
                        value={personalID}
                        class="default-select2 form-control"
                        onChange={(e) => {
                          selectpersonalQrcode(e.target.value);
                        }}
                      >
                        <option value={""}> --- Select Personal --- </option>
                        {personallist !== undefined && personallist !== null ? (
                          personallist?.map((item, i) => (
                            <option value={item?._id}>
                              {item?.name ? item?.name : "N/A"}
                            </option>
                          ))
                        ) : (
                          <></>
                        )}
                      </select>
                    </div>
                  </div>

                  <div className="col-xl-2 col-lg-2 col-md-12 mt-2 mt-lg-0 d-flex justify-content-start pl-2 pl-lg-0 px-4">
                    {/* <button className="btn  btn-primary mr-3">GO</button> */}
                    {/* <Link
                      to="/qrcodemanagement/personal-QRCode"
                      className="btn  btn-purple"
                    >
                      My Qr Code List
                    </Link> */}

                    <Link
                      to="/personal-QRCode"
                      className="btn  btn-purple"
                    >
                      My Qr Code List
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-center">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered m-b-0"
                      style={{ color: "#FFFFFF" }}
                    >
                      <thead style={{ backgroundColor: "#959595" }}>
                        <tr className="text-center">
                          <th>QR code name </th>
                          <th>Category</th>
                          <th>QR code type</th>
                          <th>Image</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="text-center">
                          <td className="align-middle">
                            {graphData?.qrCodeName
                              ? graphData?.qrCodeName
                              : ""}
                          </td>
                          <td className="align-middle">
                            {graphData?.categoryName
                              ? graphData?.categoryName + "/"
                              : ""}
                            {graphData?.subCategoryName}
                          </td>
                          <td className="align-middle">
                            {graphData?.qrCodeType
                              ? graphData?.qrCodeType
                              : ""}
                          </td>
                          <td className="align-middle ">
                            {graphData?.qrCodeString ? (
                              <QRCode
                                value={domainFrontUrl.current + graphData?.qrCodeString}
                                id="qrCodeEl"
                                size={50}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-6">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-xs-6">
                  <div style={{ padding: '15px' }}>
                    <div className="mb-3 text-grey">
                      <b className="mb-3 text-uppercase">TOTAL SCANS</b>
                    </div>
                    <div className="d-flex mb-1">
                      <h1 className="text-white mb-0 main-bold-text">
                        {graphData?.totalScanCount
                          ? graphData?.totalScanCount
                          : "0"}
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4 col-xs-6  align-items-center d-flex justify-content-end">
                  <img
                    src="../assets/img/theme/dashboard2.png"
                    alt=""
                    // height="150px"
                    // className=" d-none d-lg-block "
                    className="images-change"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card border-0 bg-dark text-white text-truncate mb-3">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-xs-6">
                  <div style={{ padding: '15px' }}>
                    <div className="mb-3 text-grey">
                      <b className="mb-3 text-uppercase">
                        Saved to stt smart wallet
                      </b>
                    </div>
                    <div className="d-flex mb-1">
                      <h1 className="text-white mb-0 main-bold-text">
                        {graphData?.totalSTTWalletSavedCount
                          ? graphData?.totalSTTWalletSavedCount
                          : "0"}
                      </h1>
                    </div>
                    <div className="d-flex align-items-center mb-1 mt-4">
                      <h1 className="text-white mb-0">
                        {" "}
                        {graphData?.totalSTTWalletSavedPercent
                          ? graphData?.totalSTTWalletSavedPercent
                          : "0"}
                        %
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-4  col-xs-6 align-items-center d-flex justify-content-end">
                  <img
                    src="../assets/img/theme/dashboard1.png"
                    alt=""
                    className="images-change"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row change-header-bg">
        <div className="col-xl-8 col-lg-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Time wise Analysis</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="mb-1">
                <h1 className="text-white mb-0">
                  {graphData !== null && graphData?.totalScanCount !== null
                    ? graphData?.totalScanCount
                    : "0"}
                </h1>
              </div>
              <div className="text-grey">
                <b className="mb-3">TOTAL SCANS</b>
              </div>
              <div style={{ height: "291px" }}>
                <div
                  className="widget-chart-full-width nvd3-inverse-mode"
                  style={{ height: "300px" }}
                >
                  {graphData !== null &&
                    graphData?.personalQrCodeTimeWiseScanList?.length > 0 ? (
                    <NVD3Chart
                      type="stackedAreaChart"
                      //datum={areaChartData}
                      datum={graphData?.personalQrCodeTimeWiseScanList}
                      height={300}
                      options={areaChartOptions}
                    />
                  ) : (
                    <></>
                  )}
                  {graphData?.personalQrCodeTimeWiseScanList?.length > 0 && (
                    <button
                      onClick={(e) => {
                        GetPersonalTimeWiseScanningAnalyticReport();
                      }}
                      type="button"
                      className="btn btn-primary btn-xs ml-3"
                    >
                      Details
                    </button>
                  )}
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>

        <PersonalTimeWiseAnalysis
        isOpen={IstimewisemodalOpen}
        toggleLableTableclosed={()=>{ToggleTimewisemodalOpen()}}
        articleTimeWiseScanListDetalis={articleTimeWiseScanListDetalis}></PersonalTimeWiseAnalysis>

       
        <div className="col-xl-4 col-lg-6 pb-4 countrywisecss">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Country wise scans</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div>
                <div className="widget-list widget-list-rounded inverse-mode ">
                  <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                      Country
                    </h4>
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1">
                      Scans
                    </h4>
                  </div>
                  {DatatablecountryWiseScanLits?.slice(0, 5).map(
                    (countryWiseitem, i) => {
                      let CountryId = countryList.find(
                        (x) => x.name === countryWiseitem.name
                      );
                      console.log(
                        "CountryId===>",
                        CountryId?.code?.toLowerCase()
                      );
                      return (
                        <>
                          <div className="widget-list-item ok">
                            <div className="widget-list-media icon">
                              <div
                                className="widget-img widget-img-xs rounded bg-inverse mr-2 width-40"
                                style={{
                                  backgroundImage: `url(https://flagpedia.net/data/flags/normal/${CountryId?.code?.toLowerCase()}.png)`,
                                }}
                              ></div>
                            </div>
                            <div className="widget-list-content  pb-1 pt-1 border-none">
                              <p className=" table-subtext">
                                {countryWiseitem?.name}
                              </p>
                            </div>

                            <div className="widget-list-action text-nowrap  pb-1 pt-1">
                              <p className="table-scan-subtext">
                                {countryWiseitem?.totalScanCount}
                              </p>
                              <button
                                onClick={(e) => {
                                  console.log("personalID==>", personalID);
                                  getCountrywisescanningDetail(countryWiseitem);
                                }}
                                type="button"
                                className="btn btn-primary btn-xs ml-3"
                              >
                                Details
                              </button>
                            </div>
                          </div>
                        </>
                      );
                    }
                  )}
                  <div className="text-center p-5">
                    {DatatablecountryWiseScanLits.length > 0 && (
                      <button
                        type="button"
                        className="btn btn-purple m-5"
                        onClick={(e) => {
                          setbestscancountryishow(true);
                          return false;
                        }}
                      >
                        See All
                      </button>
                    )}
                  </div>

                  <PersonalCountrywisescans
                    isOpen={bestscancountryishow}
                    togglecountryTableclosed={() => {
                      togglecountryTableclosed()
                    }}
                    DatatablecountryWiseScanLits={DatatablecountryWiseScanLits}
                    toggleCountry={(item) => {
                      toggleCountry(item);
                    }}
                  ></PersonalCountrywisescans>
                  <Modal
                    isOpen={modalCountry}
                    toggle={toggleCountry}
                    className="modal-size"
                  >
                    <ModalHeader
                      toggle={toggleCountry}
                      className="modalheader "
                    >
                      <div className="d-flex align-items-center">
                        <h4 className="text-white mb-0">
                          Locations country wise scans
                        </h4>

                        <button
                          className="btn btn-primary btm-sm ml-2"
                          onClick={(e) => handleActioncountry("DOWNLOAD")}
                        >
                          Download data
                        </button>
                        <CSVLink
                          headers={countrycsvheaders}
                          data={countrycsvdata}
                          // filename={'country ' + Moment(new Date()).utc().format('Y-MM-DD HH:mm:ss.SSS Z')+'.csv'}
                          filename={
                            "Country_" +
                            Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                            ".csv"
                          }
                          className="hidden"
                          ref={countrycsvRef}
                          target="_blank"
                        />
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="sparkline8-list shadow-reset">
                        <div className="sparkline8-graph table-responsive">
                          <table
                            id="data-table-buttons"
                            className="table table-striped table-bordered table-td-valign-middle text-center"
                          >
                            <thead>
                              <tr className="odd gradeA">
                                <th className="text-nowrap">Sr #</th>
                                <th className="text-nowrap">Country</th>
                                <th className="text-nowrap">City</th>
                                <th className="text-nowrap">Scans</th>
                                <th className="text-nowrap">Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Locationswisecanning.length > 0 &&
                                Locationswisecanning.map((item, i) => (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td>{item.countryName}</td>
                                    <td>
                                      {item.cityName ? item.cityName : ""}
                                    </td>
                                    <td>{item.totalScanCount}</td>
                                    <td>
                                      <button
                                        onClick={(e) => {
                                          getcitywisescanningDetail(item);
                                        }}
                                        type="button"
                                        className="btn btn-primary btn-xs ml-3"
                                      >
                                        Details
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="text-center">
                      
                      </div>
                    </ModalBody>
                  </Modal>
                  <Modal
                    isOpen={modalCity}
                    toggle={toggleCity}
                    className="modal-size"
                  >
                    <ModalHeader toggle={toggleCity} className="modalheader ">
                      <div className="d-flex align-items-center">
                        <h4 className="text-white mb-0">
                          Locations city wise scans
                        </h4>
                       
                        <button
                          className="btn btn-primary btm-sm ml-2"
                          onClick={(e) => handleActionCity("DOWNLOAD")}
                        >
                          Download data
                        </button>
                        <CSVLink
                          headers={Citycsvheaders}
                          data={Citycsvdata}
                          filename={
                            "City_" +
                            Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                            ".csv"
                          }
                          className="hidden"
                          ref={CitycsvRef}
                          target="_blank"
                        />
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      {LocationsCitywisecanning.length !== null ? (
                        <div>
                          <div className="sparkline8-list shadow-reset">
                            <div className="sparkline8-graph table-responsive">
                              {bestsCityallshow === true ? (
                                <PersonalLocationscitywisescans LocationsCitywisecanning={LocationsCitywisecanning}></PersonalLocationscitywisescans>
                              ) : (
                                <table
                                  id="data-table-buttons"
                                  className="table table-striped table-bordered table-td-valign-middle text-center"
                                >
                                  <thead>
                                    <tr className="odd gradeA">
                                      <th className="text-nowrap">Sr #</th>
                                      <th className="text-nowrap">Country</th>
                                      <th className="text-nowrap">City</th>
                                      <th className="text-nowrap">
                                        QR Code Name
                                      </th>
                                      {/* <th className="text-nowrap">Type</th> */}
                                      <th className="text-nowrap">Pic</th>
                                      <th className="text-nowrap">Scans</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {LocationsCitywisecanning.length > 0 &&
                                      LocationsCitywisecanning.slice(0, 5).map(
                                        (item, i) => (
                                          <tr>
                                            <td>{i + 1}</td>
                                            <td>{item.countryName}</td>
                                            <td>{item.cityName}</td>
                                            <td>
                                              {item.productName
                                                ? item.productName
                                                : ""}
                                            </td>
                                            <td>
                                              <div>
                                                <img
                                                  src={
                                                    Config?.contentUrl +
                                                    item?.productImagepath
                                                  }
                                                  style={{ height: "50px" }}
                                                  onError={({
                                                    currentTarget,
                                                  }) => {
                                                    currentTarget.onerror =
                                                      null; // prevents looping
                                                    currentTarget.src =
                                                      "../assets/img/mtsttqr.png";
                                                  }}
                                                ></img>
                                              </div>
                                            </td>
                                            <td>{item.totalScanCount}</td>
                                          </tr>
                                        )
                                      )}
                                  </tbody>
                                </table>
                              )}
                            </div>
                          </div>
                          <div className="text-center">
                            {bestsCityallshow === true ? (
                              <button
                                type="button"
                                className="btn btn-purple m-5"
                                onClick={(e) => {
                                  setbestsCityallshow(false);
                                }}
                              >
                                Hide
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-purple m-5"
                                onClick={(e) => {
                                  setbestsCityallshow(true);
                                }}
                              >
                                See All
                              </button>
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </ModalBody>
                  </Modal>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
      <div className="row change-header-bg">
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Operating system wise scanning</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div style={{ height: "325px" }}>
                {/* <Pie data={pieChart.data} options={pieChart.options} /> */}
                {graphData !== null && graphData?.pipeBarchat !== null ? (
                  <Pie
                    data={graphData?.pipeBarchat}
                    options={pieChart.options}
                  />
                ) : (
                  <></>
                )}
              </div>
            </PanelBody>
          </Panel>
        </div>
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Category wise scanning</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="table-responsive">
                <table
                  className="table table-bordered m-b-0"
                  style={{ color: "#FFFFFF" }}
                >
                  <thead style={{ backgroundColor: "#959595" }}>
                    <tr className="text-center">
                      <th className="table-sr-scan-width">Sr #</th>
                      <th>Category</th>
                      <th className="table-scan-width">Total Scans</th>
                    </tr>
                  </thead>
                  <tbody>
                    {graphData?.personalQrCodeCategoryWiseScanList?.length >
                      0 ? (
                      graphData?.personalQrCodeCategoryWiseScanList
                        .slice(0, 5)
                        .map((item, i) => (
                          <tr className="text-center">
                            <td className="align-middle">{i + 1}</td>
                            <td className="align-middle">
                              {item?.categoryName ? item?.categoryName : ""}
                            </td>
                            <td className="align-middle">
                              {item?.totalBestScanCount}
                              <button
                                type="button"
                                className="btn btn-primary btn-xs ml-3"
                                onClick={(e) => {
                                  togglecategory(item);
                                }}
                              >
                                Details
                              </button>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <label>No Data Found</label>
                    )}
                  </tbody>
                </table>
                <div className="text-center my-3">
                  {graphData?.personalQrCodeCategoryWiseScanList?.length > 0 ? (
                    <button
                      type="button"
                      className="btn btn-purple m-5"
                      onClick={(e) => {
                        setbestScancategoryisall(true);
                      }}
                    >
                      See All
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
                <PersonalBestScancategoryisall 
                isOpen={bestScancategoryisall} 
                toggleCetegoryTableclosed={()=>{toggleCetegoryTableclosed()}}
                DatatableCategoryListdata={DatatableCategoryList}
                togglecategory ={(item)=>{togglecategory(item)}}
                 ></PersonalBestScancategoryisall>
                
                <Modal
                  isOpen={modalCategory}
                  toggle={togglecategory}
                  className="modal-size"
                >
                  <ModalHeader toggle={togglecategory} className="modalheader ">
                    <div className="d-flex align-items-center">
                      <h4 className="text-white mb-0">
                        Category wise scanning Details
                      </h4>
                      <button
                        className="btn btn-primary btm-sm ml-2"
                        onClick={(e) => handleActionCategory("DOWNLOAD")}
                      >
                        Download data
                      </button>
                      <CSVLink
                        headers={Categorycsvheaders}
                        data={Categorycsvdata}
                        filename={
                          "Category_" +
                          Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                          ".csv"
                        }
                        className="hidden"
                        ref={CategorycsvRef}
                        target="_blank"
                      />
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <div className="sparkline8-list shadow-reset">
                      <div className="sparkline8-graph table-responsive">
                        {bestScancategorydetailsisall === false ? (
                          <table
                            id="data-table-buttons"
                            className="table table-striped table-bordered table-td-valign-middle text-center"
                          >
                            <thead>
                              <tr className="odd gradeA">
                                <th className="text-nowrap">Sr #</th>
                                <th className="text-nowrap">Main category</th>
                                <th className="text-nowrap">Sub category</th>
                                <th className="text-nowrap">Scans</th>
                                <th className="text-nowrap">Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Categorywisescanning.length > 0 &&
                                Categorywisescanning.map((item, i) => (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td>{item?.categoryName}</td>
                                    <td>{item?.subCategoryName}</td>
                                    <td>{item?.totalScanCount}</td>
                                    <td>
                                      <button
                                        onClick={(e) => {
                                          togglecategorydetail(item);
                                        }}
                                        type="button"
                                        className="btn btn-primary btn-xs ml-3"
                                      >
                                        Details
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        ) : (
                          <PersonalCategorywisescanningDetails Categorywisescanning={Categorywisescanning}togglecategorydetail={(item)=>{togglecategorydetail(item)}}></PersonalCategorywisescanningDetails>
                        )}
                       
                      </div>
                    </div>
                    <div className="text-center">
                    
                      {Categorywisescanning.length > 0 ? (
                        bestScancategorydetailsisall === false ? (
                          <button
                            type="button"
                            className="btn btn-purple m-5"
                            onClick={(e) => {
                              setbestScancategorydetailsisall(true);
                            }}
                          >
                            See All
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-purple m-5"
                            onClick={(e) => {
                              setbestScancategorydetailsisall(false);
                            }}
                          >
                            Hide
                          </button>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  </ModalBody>
                </Modal>
                <Modal
                  isOpen={modalsubCategory}
                  toggle={togglecategorydetail}
                  className="modal-size"
                >
                  <ModalHeader
                    toggle={togglecategorydetail}
                    className="modalheader "
                  >
                    <div className="d-flex align-items-center">
                      <h4 className="text-white mb-0">
                        SubCategory wise scanning
                      </h4>

                      <button
                        className="btn btn-primary btm-sm ml-2"
                        onClick={(e) => handleActionsubCategory("DOWNLOAD")}
                      >
                        Download data
                      </button>
                      <CSVLink
                        headers={Subcategorycsvheaders}
                        data={Subcategorycsvdata}
                        filename={
                          "Subcategory_" +
                          Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                          ".csv"
                        }
                        className="hidden"
                        ref={SubcategorycsvRef}
                        target="_blank"
                      />
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <div className="sparkline8-list shadow-reset">
                      <div className="sparkline8-graph table-responsive">
                        {Subbcattegorywisescanningishow === false ? (
                          <table
                            id="data-table-buttons"
                            className="table table-striped table-bordered table-td-valign-middle text-center"
                          >
                            <thead>
                              <tr className="odd gradeA">
                                <th className="text-nowrap">Sr #</th>
                                <th className="text-nowrap">Main category</th>
                                <th className="text-nowrap">Sub category</th>
                                <th className="text-nowrap">QR Code Name</th>
                                <th className="text-nowrap">Image</th>
                                <th className="text-nowrap">Scans</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Subbcattegorywisescanning.length > 0 &&
                                Subbcattegorywisescanning.map((item, i) => (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td>{item.categoryName}</td>
                                    <td>{item.subCategoryName}</td>
                                    <td>
                                      {item.productName
                                        ? item.productName
                                        : ""}
                                    </td>
                                    <td>
                                      <div>
                                        <img
                                          src="../assets/img/mtsttqr.png"
                                          style={{ height: "50px" }}
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null; // prevents looping
                                            currentTarget.src =
                                              "../assets/img/noimage.jpg";
                                          }}
                                        ></img>
                                       
                                      </div>
                                    </td>
                                    <td>{item.totalScanCount}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        ) : (
                          <PersonalSubbcattegorywisescanningtable Subbcattegorywisescanning={Subbcattegorywisescanning}></PersonalSubbcattegorywisescanningtable>
                          )}
                      </div>
                    </div>
                    <div className="text-center">
                      {Subbcattegorywisescanning.length > 0 ? (
                        Subbcattegorywisescanningishow === false ? (
                          <button
                            type="button"
                            className="btn btn-purple m-5"
                            onClick={(e) => {
                              setSubbcattegorywisescanningishow(true);
                            }}
                          >
                            See All
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-purple m-5"
                            onClick={(e) => {
                              setSubbcattegorywisescanningishow(false);
                            }}
                          >
                            Hide
                          </button>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                  </ModalBody>
                </Modal>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};
export default Personalreports;
